import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  /* ---------- STATES ---------- */
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ---------- HANDLERS ---------- */
  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.get(
        "https://hotelapi.shriyanshnath.com/api/Validate_User",
        {
          params: {
            username: values.email,
            pwd: values.password,
          },
        }
      );

      // ✅ API success condition
      if (response.data && response.data.length > 0) {
        // optional: user data store
        localStorage.setItem("loginUser", JSON.stringify(response.data[0]));

        setShowModal(true); // 🔥 modal open
      } else {
        toast.error("Invalid username or password");
      }
    } catch (err) {
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  /* ---------- UI ---------- */
  return (
    <div className="login-bg">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} md={6} lg={4}>
            <Card className="login-card shadow-lg">
              <Card.Body>
                <div className="text-center mb-4">
                  <div className="login-logo">LOG</div>
                  <h3 className="mt-3">Welcome Back</h3>
                  <p className="text-muted">Please login to your account</p>
                </div>

                {/* ERROR MESSAGE */}
                {error && (
                  <div className="alert alert-danger py-2 text-center">
                    {error}
                  </div>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Enter username"
                      value={values.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Enter password"
                      value={values.password}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Form.Check label="Remember me" />
                    <a href="#" className="forgot-link">
                      Forgot password?
                    </a>
                  </div>

                  <Button
                    type="submit"
                    className="w-100 login-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          size="sm"
                          animation="border"
                          className="me-2"
                        />
                        Signing In...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </Button>
                </Form>

                <div className="text-center mt-3">
                  <small>
                    Don’t have an account? <a href="#">Sign Up</a>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} backdrop="static" centered keyboard={false}>
        <Modal.Header>
          <Modal.Title className="text-center w-100">
            What do you want to book?
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <p>Please select an option to continue</p>

          <div className="d-grid gap-3">
            <Button
              variant="primary"
              onClick={() => {
                setShowModal(false);
                navigate("/advance-booking");
              }}
            >
              🏨 Book Room
            </Button>

            <Button
              variant="success"
              onClick={() => {
                setShowModal(false);
                navigate("/banquet");
              }}
            >
              🎉 Book Banquet
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;
